import React, { useEffect } from 'react';

const LanguageTranslator = () => {

  useEffect(() => {
    // Auto-detect and set default language on first visit
    const initializeDefaultLanguage = () => {
      const savedLang = localStorage.getItem('googleTranslateLang');
      if (!savedLang) {
        const browserLang = navigator.language || navigator.userLanguage;
        let defaultLang = 'en';

        if (browserLang.startsWith('hi')) defaultLang = 'hi';
        else if (browserLang.startsWith('mr')) defaultLang = 'mr';
        else if (browserLang.startsWith('ar')) defaultLang = 'ar';

        if (defaultLang !== 'en') {
          localStorage.setItem('googleTranslateLang', defaultLang);
          setGoogleTranslateCookie(defaultLang);
          window.location.reload();
        }
      }
    };

    // Set Google Translate cookie
    const setGoogleTranslateCookie = (lang) => {
      document.cookie = `googtrans=/en/${lang}; path=/; max-age=31536000`;
    };

    // Get stored language preference
    const storedLang = localStorage.getItem('googleTranslateLang');
    if (storedLang && storedLang !== 'en') {
      setGoogleTranslateCookie(storedLang);
    }

    // Define Google Translate callback
    window.googleTranslateElementInit = () => {
      try {
        new window.google.translate.TranslateElement(
          {
            pageLanguage: 'en',
            includedLanguages: 'en,hi,mr,ar',
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false,
          },
          'google_translate_element'
        );
      } catch (error) {
        console.warn('Google Translate initialization error:', error);
      }
    };

    // Load Google Translate script with error handling
    const loadGoogleTranslateScript = () => {
      const existingScript = document.getElementById('google-translate-script');
      if (!existingScript) {
        const script = document.createElement('script');
        script.id = 'google-translate-script';
        script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
        script.async = true;
        script.onerror = () => {
          console.warn('Failed to load Google Translate script');
        };
        document.body.appendChild(script);
      }
    };

    // Hide Google Translate UI elements
    const hideGoogleTranslateUI = () => {
      const styleId = 'google-translate-style';
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.innerHTML = `
          #google_translate_element {
            display: none !important;
          }
          .goog-te-banner-frame.skiptranslate {
            display: none !important;
          }
          body {
            top: 0px !important;
            position: static !important;
          }
          .goog-te-gadget {
            font-family: inherit;
          }
          .goog-te-gadget .goog-te-combo {
            font-size: 14px;
          }
        `;
        document.head.appendChild(style);
      }
    };

    initializeDefaultLanguage();
    hideGoogleTranslateUI();
    loadGoogleTranslateScript();
  }, []);

  // Expose language switching function globally for Navigation/Footer components
  useEffect(() => {
    window.switchLanguage = (lang) => {
      if (lang === 'en') {
        document.cookie = 'googtrans=; path=/; max-age=0';
        localStorage.removeItem('googleTranslateLang');
      } else {
        document.cookie = `googtrans=/en/${lang}; path=/; max-age=31536000`;
        localStorage.setItem('googleTranslateLang', lang);
      }
      window.location.reload();
    };
  }, []);

  return (
    <div id="google_translate_element" style={{ display: 'none' }}></div>
  );
};

export default LanguageTranslator;
